import { FC, memo } from 'react';

import { ModalTypes, useModalContext } from 'application/providers/ModalProvider';
import { VideoPricePlan } from 'application/components/VideoPricePlan';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { TEXTS } from './texts';

import styles from './ShowVideoPricePlanButton.module.scss';

export const ShowVideoPricePlanButton: FC = memo(() => {
  const { openModal, closeModal } = useModalContext();

  const showVideoPricePlan = () => {
    openModal(ModalTypes.CUSTOM, {
      title: TEXTS.BUTTON_TEXT,
      description: <VideoPricePlan withTitle={false} />,
      actionButtons: [
        <Button
          key="button_hide_video_price_plan"
          elementId="button_hide_video_price_plan"
          type={ButtonType.PRIMARY}
          onClick={() => closeModal(1)}>
          {TEXTS.CLOSE_TEXT}
        </Button>,
      ],
      hideCloseButton: true,
    });
  };

  return (
    <Button
      elementId="button_show_video_price_plan"
      type={ButtonType.PLAIN}
      className={styles.button}
      onClick={showVideoPricePlan}>
      {TEXTS.BUTTON_TEXT}
    </Button>
  );
});
